import { render, staticRenderFns } from "./BannerWidget.vue?vue&type=template&id=68366c66"
import script from "./BannerWidget.vue?vue&type=script&setup=true&lang=ts"
export * from "./BannerWidget.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BannerWidget.vue?vue&type=style&index=0&id=68366c66&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports